import { QueryClient } from '@tanstack/react-query';

let _queryClient: QueryClient | null = null;

export function getQueryClient() {
  if (!_queryClient) {
    _queryClient = new QueryClient({
      defaultOptions: {
        queries: {
          retry: false,
          refetchOnWindowFocus: false,
        },
      },
    });
  }

  return _queryClient;
}
